import { RouterProvider } from 'react-router-dom';
import './App.scss';
import router from './router';
import { ToastContainer } from 'react-toastify';
import { Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrandProvider } from './branding';
import { useAuthExpiredHandler } from './hooks/useAuthExpiredHandler';
import { useEffect } from 'react';
import { loadAuthSession } from './utils/authSession';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes - keep unused data in cache for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnReconnect: true, // Refetch when reconnecting to network
      retry: 1, // Only retry once on failure
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000) // Exponential backoff
    },
    mutations: {
      retry: 1 // Only retry mutations once
    }
  }
});

function App() {
  // Clear the React Query cache when a session expires (401). The event is
  // dispatched by the axios interceptor in services/api.ts.
  useAuthExpiredHandler(queryClient);

  // Hydrate auth from the server on boot when a token is stored. Capability
  // gates stay closed until it resolves; a failed fetch keeps them closed.
  useEffect(() => {
    void loadAuthSession();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrandProvider>
        <>
          <RouterProvider router={router} />
          <div id="modal-root"></div>
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            transition={Bounce}
          />
        </>
      </BrandProvider>
    </QueryClientProvider>
  );
}

export default App;
